import { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import canvas from 'canvas-txt';
import Modal from '../../../Util/Modal/CustomModal';
import Fetch from "../../../functions/Fetch";
import QRCode from "react-qr-code";

function WhatsAppQRCODE(props) {
    let [qr, setQR] = useState('');
    let [modalTitle, setModalTitle] = useState('');
    let [showModal, setShowModal] = useState(false);
    let [modalContent, setModalContent] = useState('');
    let [button, setNamebutton] = useState('Gerar qrcode');
    let className = '';
    let interval = false;
    const status =  'status_'+props.name;

    const onQrcode = async () => {
        Fetch.post(props.endpoint,{'id': props.id}).then((res) => {
            if(res[status] != '1' && !res[props.name]){
                Fetch.post(props.endpointqrcode,{'phone_from': res[props.phone_name],'token':props.token,'qrcode': props.name});
            }
            if(res.status_qrcode_1 == '' || res.status_qrcode_1 == '0'){
                setShowModal(true);
                setModalTitle('Autenticar Qrcode Whatsapp');
                qrcode();
                interval = setInterval(() => {
                    qrcode();
                }, 5000);
            }

            if(res.status_qrcode_1 == '1'){
                Fetch.post(props.endpointlogout,{'phone_from': res[props.phone_name],'token':props.token});
                setNamebutton('Gerar QrCode');
            }
        });
    }

    const buttonName = async () => {
        Fetch.post(props.endpoint,{'id': props.id}).then((res) => {
            if(res.status_qrcode_1 == ''){
                setNamebutton('Gerar QrCode');
            }

            if(res.status_qrcode_1 == '0'){
                setNamebutton('Autenticar QrCode');
            }

            if(res.status_qrcode_1 == '1'){
                setNamebutton('Desconectar');
            }
        });
    }

    useEffect(() => {
        buttonName();
        return () => {
            clearInterval(interval);
        };
    }, []);

    const qrcode = () => {
        Fetch.post(props.endpoint,{'id': props.id}).then((res) => {
            if(!res[status] || !res[props.name]){
                setModalContent(
                    <>
                        <p align="center">Carregando...</p>
                    </>
                );
            }else if(res[status] == 0 || !res[status]){
                setModalContent(
                    <div align="center">
                        <QRCode width="700" height="400" value={res[props.name]} />
                    </div>
                );

                //<canvas id="qrcode" width="700" height="400"></canvas>
                /*const c = document.getElementById('qrcode');
                const ctx = c.getContext('2d');
            
                ctx.clearRect(0, 0, 470,400);
                const txt = res[props.name];
                ctx.fillStyle = '#fff';
                canvas.font = 'Courier new';
                canvas.fontSize = 10;
                canvas.align = 'center';
                canvas.lineHeight = 12;
                canvas.drawText(ctx, txt, 0,0, 470, 400);*/
            }

            if(res[status] == 1){
                clearInterval(interval);
                setModalContent(
                    <div>
                        <p align="center">Whatsapp autenticado.</p>
                    </div>
                );
                setNamebutton('Desconectar');
            }
        });
    }

    if (props.error) {
        className = "is-invalid";
    }
    return (
        <div>
            <Modal
                show={showModal}
                handleShow={() => setShowModal(true)}
                handleClose={() => setShowModal(false)}
                title={modalTitle}
                content={modalContent}
                showButtons={false}
                showHeader={true}
                size='30%'
            />
            {!props.readOnly && (
                <button onClick={onQrcode} type="button" className="btn btn-primary">{button}</button>
            )}
            
        </div>
    );
}
export default WhatsAppQRCODE;
